import { render } from "./SettingsSvg.vue?vue&type=template&id=32f480a4"
import script from "./SettingsSvg.vue?vue&type=script&lang=js"
export * from "./SettingsSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__